var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FBC115"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94875 17V8.28L4.96475 8.808V7.08L7.87675 5.8H9.18875V17H6.94875ZM11.0969 17V15.416C11.7795 14.872 12.4409 14.328 13.0809 13.784C13.7315 13.24 14.3129 12.7013 14.8249 12.168C15.3369 11.624 15.7422 11.096 16.0409 10.584C16.3395 10.072 16.4889 9.576 16.4889 9.096C16.4889 8.79733 16.4355 8.52533 16.3289 8.28C16.2222 8.024 16.0515 7.82133 15.8169 7.672C15.5929 7.512 15.2942 7.432 14.9209 7.432C14.5475 7.432 14.2329 7.51733 13.9769 7.688C13.7209 7.85867 13.5289 8.088 13.4009 8.376C13.2729 8.65333 13.2089 8.968 13.2089 9.32H11.1129C11.1449 8.49867 11.3315 7.81067 11.6729 7.256C12.0142 6.70133 12.4729 6.29067 13.0489 6.024C13.6249 5.74667 14.2702 5.608 14.9849 5.608C15.7742 5.608 16.4409 5.75733 16.9849 6.056C17.5289 6.344 17.9395 6.73867 18.2169 7.24C18.5049 7.74133 18.6489 8.31733 18.6489 8.968C18.6489 9.45867 18.5582 9.93867 18.3769 10.408C18.2062 10.8773 17.9609 11.336 17.6409 11.784C17.3315 12.2213 16.9795 12.6427 16.5849 13.048C16.1902 13.4533 15.7795 13.8427 15.3529 14.216C14.9262 14.5787 14.5102 14.92 14.1049 15.24H18.9209V17H11.0969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge12);
export default __webpack_public_path__ + "static/media/age-12.4f4e48072b5847b30acfba2e74d489df.svg";
export { ForwardRef as ReactComponent };